import styled from "styled-components";
import {
  inputBorderColor,
  mediumFont,
  newsecondaryColor,
} from "@app/styles";

export const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  position: fixed;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  z-index: 10;
`;

export const Backdrop = styled.div`
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
`;

export const DialogContainer = styled.div`
  display: flex;
  flex-direction: column;
  min-width: 400px;
  max-width: 70vw;
  position: relative;
  background-color: #fff;
  border: 1px solid rgba(0, 0, 0, 0.2);
  border-radius: 7px;
  box-shadow: 0 1px 12px rgba(0, 0, 0, 0.15), 0 0 1px rgba(0, 0, 0, 0.25);
  @media (max-width: 575px) {
    min-width: calc(100vw - 16px);
    max-width: calc(100vw - 16px);
  }
  @media (min-width: 576px) and (max-width: 991px){
    max-width: 85vw;
  }
`;

export const Header = styled.div`
  display: flex;
  align-items: center;
  height: 72px;
  padding: 0 40px;
  @media (max-width: 575px) {
    padding: 0 24px;
  }
`;

export const Title = styled.h4`
  flex: 1;
  font-size: 20px;
  font-family: "Filson";
  ${mediumFont};
  color: ${newsecondaryColor};
`;

export const CloseIcon = styled.div`
  cursor: pointer;
  &.self-positioned {
    position: absolute;
    top: 12px;
    right: 12px;
  }
`;

export const DialogContent = styled.div`
  max-height: 75vh;
  overflow: auto;
  display: flex;
  flex-direction: column;
  &.dialog-with-form {
    max-height: unset;
    overflow: hidden;
    form {
      .form-in-dialog {
        padding: 24px 40px;
        max-height: 75vh;
        overflow: auto;
      }
      &.tab-layout {
        width: 50vw;
        display: flex;
        flex-direction: column;
        border-top: 1px solid ${inputBorderColor};
        @media (max-width: 575px) {
          width: 100%;
        }
        @media (min-width: 576px) and (max-width: 991px){
          width: 80vw;
        }
      }
    }
  }
`;

export const Body = styled.div`
  flex: 1;
  padding: 24px;
`;

export const Footer = styled.div`
  padding: 12px 24px;
  border-top: 1px solid rgba(0, 0, 0, 0.12);
`;

export const DialogFooter = styled.div`
  height: 80px;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  border-top: 2px solid ${inputBorderColor};
  padding: 0 64px;
  box-sizing: border-box;
  &.with-no-border {
    border: none;
  }
  &.alt-padding {
    padding: 0 48px;
  }
  &.alt-height {
    height: 72px;
  }
  &.h-unset {
    height: unset;
  }
  button:not(:last-child) {
    margin-right: 8px;
  }
`;

export const ChangeConfirmationContentWrapper = styled.div`
  width: 400px;
  padding: 32px;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const ChangeDialogConfirmationText = styled.p`
  font-size: 14px;
  line-height: 1.5;
  margin: 16px 0;
`;
